import { useCallback, useEffect, useState } from 'react'

function useService<S, R>(
    promiseFunction: (req?: R) => Promise<S>,
    onComplete?: (result: S) => void,
    onError?: (error: unknown) => void
) {
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState<S>()
    const [error, setError] = useState<unknown>()
    const trigger: (req?: R) => Promise<S> = useCallback(
        (req?: R) => {
            setIsLoading(true)
            setError(undefined)
            return promiseFunction(req).then(
                res => {
                    setIsLoading(false)
                    setData(res)
                    return res
                },
                err => {
                    setIsLoading(false)
                    setError(err || true)
                    onError && onError(err)
                    if (!(err instanceof Error)) {
                        return Promise.reject(new Error(String(err)))
                    } else {
                        return Promise.reject(err)
                    }
                }
            )
        },
        [onError, promiseFunction]
    )

    useEffect(() => {
        if (data && onComplete) {
            onComplete(data)
        }
    }, [data, onComplete])

    return {
        trigger,
        isLoading,
        data,
        error,
    }
}
export default useService
